import { QUERY_KEYS, soCaiColumns, theKhoColumns, thueVatDauVaoColumns } from '@/constants';
import { InfoDropdown } from '@/components/custom/erp';

const ButToanHuyInfoDropdown = ({ uuid, ma_ct }: { uuid: string; ma_ct?: string }) => (
  <InfoDropdown
    uuid={uuid}
    ma_ct={ma_ct}
    tableItems={[
      {
        title: 'Xem sổ cái',
        endpoint: QUERY_KEYS.SO_CAI,
        columns: soCaiColumns,
        group: 1
      },
      {
        title: 'Thuế VAT đầu vào',
        endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO,
        columns: thueVatDauVaoColumns,
        group: 1
      }
    ]}
  />
);

export default ButToanHuyInfoDropdown;
